<template>
  <Modal :open="true" size="small">
    <div class="dwp-space-y-4">
      <div>
        <Logo class="dwp-h-5 dwp-mb-4" />
        <div class="dwp-font-medium dwp-text-xl">Update Required</div>
        <div
          class="dwp-text-gray-600 dwp-text-sm"
        >Please update your Docket WP plugin to the latest version.</div>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/ui/Modal.vue";
import Logo from "@/components/illustrations/Logo.vue";
import { sync, call } from "vuex-pathify";

export default {
  components: {
    Modal,
    Logo
  },
  computed: {
    open: sync("ui/open")
  }
};
</script>